<ng-container *ngFor="let page of reviewablePages()">
  <section *ngIf="page.visible && showInReview(page)">

    <div class="bl-margin-bottom--40">
      <h2 class="bl-font-size--32 bl-font-weight--900 bl-font-color--black bl-margin-bottom--0">
        {{isOLALoan ? page.customTitleOrDefault : page.customTitleOrDefault | titlecase }}</h2>
      <div class="dx-workflow-card bl-block-module bl-margin-top--16">
        <ng-container *ngIf="page?.config?.reviewRendererType; else defaultTemplate">
          <cu-review-resolver [reviewComponentType]="page.config.reviewRendererType"
           [flow]="flow" [page]="page" [editUrlFn]="editUrlFn"></cu-review-resolver>
        </ng-container>
        <ng-template #defaultTemplate>
          <div *ngFor="let card of getReviewCards(page);let allowEdit=first">
            <ecp-review-card [card]="card" [flow]="flow" [page]="page" [editUrlFn]="editUrlFn" [allowEdit]="allowEdit">
            </ecp-review-card>
          </div>
        </ng-template>
      </div>
    </div>

  </section>
  <!-- Commenting Morgage related Components -->
  <section *ngIf="page.visible && showBeneficiaryReview(page.id)">
    <ecp-oao-beneficiary-review></ecp-oao-beneficiary-review>
  </section>
</ng-container>

<section *ngIf="isOLALoan">
  <ecp-ola-loan-protection-options></ecp-ola-loan-protection-options>
</section>